import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

const TOKEN_KEY = "fluent_token";

// Auth uses opaque 7-day session tokens sent as a Bearer header (stored in
// localStorage). We intentionally do NOT use withCredentials/cookies: the backend
// and frontend are served from different subdomains in this environment, so
// third-party cookies are unreliable, and credentialed requests are incompatible
// with the wildcard CORS origin. Tokens are opaque (no embedded secrets), not JWTs.
export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common["Authorization"];
  }
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

// hydrate on load
const existing = getToken();
if (existing) api.defaults.headers.common["Authorization"] = `Bearer ${existing}`;

export default api;
